import { IconProps } from "../../utils/global-types/global-types";

const ApplyFiltersIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 15 14"
    className={className || "w-[15px] h-[14px]"}
    {...rest}
  >
    <circle cx="11.054" cy="10.041" r="2.211" fill="currentColor"></circle>
    <circle
      cx="2.211"
      cy="2.211"
      r="2.211"
      fill="currentColor"
      transform="matrix(-1 0 0 1 5.336 1.75)"
    ></circle>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.005"
      d="M7.474 9.989H2.088M6.697 3.91h5.387"
    ></path>
  </svg>
  );
};

export default ApplyFiltersIcon;

